import {Component, OnInit, ViewChild} from '@angular/core';
import {MatPaginator} from '@angular/material/paginator';
import {MatTableDataSource} from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LogsData } from 'src/app/model/LogsData';
import { BackOffServiceService } from 'src/app/services/back-off-service.service';
import { environment } from 'src/environments/environment';
import * as Parse from 'parse';

export interface FoodHistoryData {
  food: string;
  calories: string;
  meal: string;
  date: string;
}

@Component({
  selector: 'app-food-history',
  templateUrl: './food-history.component.html',
  styleUrls: ['./food-history.component.css']
})

export class FoodHistoryComponent implements OnInit {
  displayedColumns: string[] = ['food', 'calories', 'meal', 'date'];
  dataSource = new MatTableDataSource<FoodHistoryData>();
  data: LogsData[];
  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map(result => result.matches)
  );
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(
    private breakpointObserver: BreakpointObserver,
    private _bkoffService: BackOffServiceService
  ) {
    Parse.initialize(environment.PARSE_APP_ID, environment.PARSE_JS_KEY);
    (Parse as any).serverURL = environment.serverURL;
  }

  ngOnInit() {
    var FOOD_DATA : FoodHistoryData[] = [];

    this._bkoffService.getFoodHistory().then((res) => {
      this.data = res;
      console.log(res);
      this.data.forEach(element => {
        if (element.calories != null) {
          FOOD_DATA.push({food: element.food_name, calories: element.calories.toString(), meal: element.meal_type, date: element.foodDate});
        } else {
          FOOD_DATA.push({food: element.food_name, calories: "N/A", meal: element.meal_type, date: element.foodDate});
        }
      });  
      this.dataSource = new MatTableDataSource<FoodHistoryData>(FOOD_DATA);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    });

  }

}

